import React from 'react';
import * as query from '../helpers/query';
import * as photosService from '../services/photos';
import * as photoSetsService from '../services/photoSets';
import withAuthentication from '../withAuthentication';
import OnionCamera from '../OnionCamera';

class Camera extends React.Component {

    constructor(props) {

        super(props);

        const params = new URLSearchParams(props.location.search);

        this.state = {

            photoSet: null,
            photoSetId: params.has('photoSet') ? Number(params.get('photoSet')) : null,
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {

        if (this.state.photoSetId)
            photoSetsService.getById(this.state.photoSetId).then(result => result.item).then(photoSet => this.setState({photoSet}));
    }

    getOverlay() {

        return this.state.photoSet ? this.state.photoSet.photos[0].filename : '';
    }

    handleClose() {
        this.props.history.push("/");

    }

    async handleSave(e) {

        const payload = {

            description: e.description,
            device: this.props.auth.device,
            photoSetId: this.state.photoSetId,
            tags: e.tags,
            uri: e.data,
        };

        if (e.position) {

            const {accuracy, latitude, longitude} = e.position.coords;

            Object.assign(payload, {

                accuracy,
                latitude,
                longitude,
            });
        }

        await photosService.save(payload).then(() => this.redirect()).catch((err) => console.log(err));
    }

    redirect() {
        this.props.history.push({
            pathname: '/',
            search: query.buildQueryString({activePhotoSet: this.state.photoSetId }),
        });
    }

    render() {
        return <OnionCamera overlay={this.getOverlay()} onClose={this.handleClose} onSave={this.handleSave} style={{width: '100vw', height: '100vh'}}/>;
    }
}

export default withAuthentication(Camera);



// WEBPACK FOOTER //
// ./src/components/pages/Camera.js